import { CountUserChildren } from "@/interfaces/user";
import { api } from "@/services/api";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const fetchCountAffiliates = (
  id: number,
  options?: Partial<UseQueryOptions<CountUserChildren>>
) => {
  const response = useQuery({
    queryKey: ["user/countChildUsers", id],
    queryFn: async () => {
      const res = await api.get(`/user/countChildUsers/${id}`);
      return res.data.data;
    },
    ...options,
  });

  return response;
};
